"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorIcon = void 0;
var _icons = require("@ori-ui/icons");
var _react = _interopRequireDefault(require("react"));
var _icons2 = require("./icons");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorIcon = ({
  errorCode
}) => {
  switch (errorCode) {
    case 1:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons2.SettingsIcon, {});
    case 401:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Lock, {
        sx: {
          fontSize: '4em'
        }
      });
    case 404:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons2.GlassesIcon, {});
    case 500:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons2.SettingsIcon, {});
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons2.SettingsIcon, {});
  }
};
exports.ErrorIcon = ErrorIcon;
